import React from 'react'
import PropTypes from 'prop-types'
import Table from 'react-bootstrap/Table'
import styled from 'styled-components'
import { Card } from 'react-bootstrap'
import { breakpoints } from 'globalStyles'

const StyledBaseCard = styled(Card)`
  height: auto !important;
  table {
    width: 100%;
    td {
      padding: 0px;
      @media ${breakpoints.desktop} {
        padding: 3px;
      }
    }
  }
`

const BaseCard = ({ children, title, companyLogo }) => {
  return (
    <StyledBaseCard>
      <Card.Body>
        <Table borderless>
          <tbody>
            <tr>
              <td>{title}</td>
              <td rowSpan="2" className="text-center">
                {companyLogo !== null && <div style={{ float: 'inline-end' }}>{companyLogo}</div>}
              </td>
            </tr>
            <tr>
              <td>{children}</td>
            </tr>
          </tbody>
        </Table>
      </Card.Body>
    </StyledBaseCard>
  )
}

BaseCard.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.node,
  companyLogo: PropTypes.node,
}

BaseCard.defaultProps = {
  companyLogo: null,
  title: '',
}

export default BaseCard
